<template>
  <div>
    <!-- 搜索和操作栏 -->
    <div style="margin: 10px 0">
      <el-input
        style="width: 200px;"
        v-model="searchName"
        placeholder="请输入设备名称"
        suffix-icon="el-icon-search"
        clearable
        @clear="load"
        @keyup.enter.native="load"
      ></el-input>
      <el-button style="margin-left: 10px;" type="primary" @click="load" icon="el-icon-search">搜索</el-button>

      <!-- 公司筛选（仅超级管理员可见） -->
      <el-select v-if="user.role === '超级管理员'" v-model="searchCompanyId" placeholder="选择公司" clearable style="margin-left: 10px; width: 150px;" @change="onCompanyFilterChange">
        <el-option v-for="company in companies" :key="company.id" :label="company.name" :value="company.id"></el-option>
      </el-select>

      <!-- 大棚筛选 -->
      <el-select v-model="searchGreenhouseId" placeholder="选择大棚" clearable style="margin-left: 10px; width: 150px;" @change="load">
        <el-option v-for="gh in filteredGreenhouses" :key="gh.id" :label="gh.name" :value="gh.id"></el-option>
      </el-select>

      <!-- 操作按钮（超级管理员和管理员可见） -->
      <el-button v-if="user.role !== '用户'" style="float:right; margin-left: 10px" type="danger" @click="deleteBatch">批量删除</el-button>
      <el-button v-if="user.role !== '用户'" style="float:right;" type="primary" @click="handleAdd" icon="el-icon-circle-plus-outline">新增设备</el-button>
    </div>

    <!-- 设备列表 -->
    <el-table
      :data="tableData"
      border
      stripe
      :header-cell-class-name="headerBg"
      @selection-change="handleSelectionChange"
    >
      <el-table-column v-if="user.role !== '用户'" type="selection" width="55"></el-table-column>
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="deviceName" label="设备名称" min-width="120"></el-table-column>
      <el-table-column prop="companyName" label="所属公司" min-width="120">
        <template slot-scope="scope">
          {{ scope.row.companyName || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="greenhouseName" label="所属大棚" min-width="120">
        <template slot-scope="scope">
          {{ scope.row.greenhouseName || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="sid" label="设备SID" min-width="120"></el-table-column>
      <el-table-column prop="deviceType" label="设备类型" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.deviceType === 'switch' ? '开关' : (scope.row.deviceType === 'value' ? '数值' : scope.row.deviceType) }}
        </template>
      </el-table-column>
      <el-table-column prop="controlPid" label="控制PID" min-width="120"></el-table-column>
      <el-table-column label="状态" min-width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
            {{ scope.row.status === 1 ? '在线' : '离线' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" min-width="160"></el-table-column>
      <el-table-column v-if="user.role !== '用户'" label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleEdit(scope.row)" style="margin-right: 5px">编辑</el-button>
          <el-button type="danger" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div style="padding: 10px 0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <!-- 编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" :before-close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="设备名称" prop="deviceName">
          <el-input v-model="form.deviceName" placeholder="请输入设备名称"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="设备SID" prop="sid">
              <el-input v-model="form.sid" placeholder="请输入设备SID"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备类型" prop="deviceType">
              <el-select v-model="form.deviceType" placeholder="选择设备类型" style="width: 100%;">
                <el-option label="开关" value="switch"></el-option>
                <el-option label="数值" value="value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="控制PID" prop="controlPid">
          <el-input v-model="form.controlPid" placeholder="请输入控制寄存器PID"></el-input>
        </el-form-item>

        <!-- 所属公司（仅超级管理员可见） -->
        <el-row :gutter="20" v-if="user.role === '超级管理员'">
          <el-col :span="12">
            <el-form-item label="所属公司" prop="companyId">
              <el-select v-model="form.companyId" placeholder="选择所属公司" @change="onFormCompanyChange" style="width: 100%;">
                <el-option v-for="company in companies" :key="company.id" :label="company.name" :value="company.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属大棚" prop="greenhouseId">
              <el-select v-model="form.greenhouseId" placeholder="选择所属大棚" style="width: 100%;">
                <el-option v-for="gh in formFilteredGreenhouses" :key="gh.id" :label="gh.name" :value="gh.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 所属大棚（管理员和用户可见，自动限定本公司大棚） -->
        <el-row :gutter="20" v-if="user.role === '管理员' || user.role === '用户'">
          <el-col :span="24">
            <el-form-item label="所属大棚" prop="greenhouseId">
              <el-select v-model="form.greenhouseId" placeholder="选择所属大棚" style="width: 100%;">
                <el-option v-for="gh in filteredGreenhouses" :key="gh.id" :label="gh.name" :value="gh.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="排序" prop="sortOrder">
              <el-input-number v-model="form.sortOrder" :min="0" :max="999" style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-select v-model="form.status" placeholder="选择状态" style="width: 100%;">
                <el-option label="离线" :value="0"></el-option>
                <el-option label="在线" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ControlDevice",
  data() {
    return {
      tableData: [],
      searchName: '',
      searchCompanyId: null,
      searchGreenhouseId: null,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: '新增设备',
      isEdit: false,
      submitLoading: false,
      multipleSelection: [],
      headerBg: 'headerBg',
      user: JSON.parse(localStorage.getItem("user") || '{}'),
      companies: [],
      greenhouses: [],
      filteredGreenhouses: [],
      formFilteredGreenhouses: [],

      form: {
        id: null,
        deviceName: '',
        sid: '',
        deviceType: 'switch',
        controlPid: '',
        companyId: null,
        greenhouseId: null,
        sortOrder: 0,
        status: 0
      },

      rules: {
        deviceName: [
          { required: true, message: '请输入设备名称', trigger: 'blur' }
        ],
        sid: [
          { required: true, message: '请输入设备SID', trigger: 'blur' }
        ],
        deviceType: [
          { required: true, message: '请选择设备类型', trigger: 'change' }
        ],
        controlPid: [
          { required: true, message: '请输入控制PID', trigger: 'blur' }
        ],
        greenhouseId: [
          { required: true, message: '请选择所属大棚', trigger: 'change' }
        ]
      }
    }
  },

  mounted() {
    this.loadOptions();
    this.load();
  },

  methods: {
    load() {
      this.request.get('/api/equipment/control-devices/page', {
        params: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          name: this.searchName || undefined,
          companyId: this.searchCompanyId || undefined,
          greenhouseId: this.searchGreenhouseId || undefined
        }
      }).then(res => {
        if (res.code === "200") {
          this.tableData = res.data.records || [];
          this.total = res.data.total || 0;
        }
      });
    },

    onCompanyFilterChange() {
      this.searchGreenhouseId = null;
      if (this.searchCompanyId) {
        this.filteredGreenhouses = this.greenhouses.filter(gh => gh.companyid === this.searchCompanyId);
      } else {
        this.filteredGreenhouses = [...this.greenhouses];
      }
      this.load();
    },

    loadOptions() {
      this.request.get('/api/equipment/control-devices/options').then(res => {
        if (res.code === "200") {
          this.greenhouses = res.data.greenhouses || [];

          // 非超级管理员只能看到本公司的大棚
          if (this.user.role !== '超级管理员') {
            const userCompanyId = this.user.companyid;
            this.greenhouses = this.greenhouses.filter(gh => gh.companyid === userCompanyId);
          }

          this.filteredGreenhouses = [...this.greenhouses];

          // 加载公司列表（仅超级管理员）
          if (this.user.role === '超级管理员') {
            this.request.get('/api/companies/').then(res => {
              if (res.code === "200") {
                this.companies = res.data || [];
              }
            });
          }
        }
      });
    },

    handleAdd() {
      this.dialogTitle = '新增设备';
      this.isEdit = false;
      this.resetForm();
      this.dialogVisible = true;
    },

    handleEdit(row) {
      this.dialogTitle = '编辑设备';
      this.isEdit = true;

      this.request.get(`/equipment/control-devices/${row.id}`).then(res => {
        if (res.code === "200") {
          const data = res.data;
          this.form = {
            id: data.id,
            deviceName: data.deviceName,
            sid: data.sid,
            deviceType: data.deviceType || 'switch',
            controlPid: data.controlPid,
            companyId: data.companyId,
            greenhouseId: data.greenhouseId,
            sortOrder: data.sortOrder || 0,
            status: data.status || 0
          };
          // 加载表单公司对应的大棚
          if (this.form.companyId) {
            this.formFilteredGreenhouses = this.greenhouses.filter(gh => gh.companyid === this.form.companyId);
          }
          this.dialogVisible = true;
        }
      });
    },

    handleDelete(id) {
      this.$confirm('确定删除该设备吗？删除后无法恢复。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.request.delete(`/equipment/control-devices/${id}`).then(res => {
          if (res.code === "200") {
            this.$message.success('删除成功');
            this.load();
          } else {
            this.$message.error(res.message || '删除失败');
          }
        });
      });
    },

    deleteBatch() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请选择要删除的设备');
        return;
      }

      this.$confirm(`确定删除选中的 ${this.multipleSelection.length} 个设备吗？删除后无法恢复。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const ids = this.multipleSelection.map(item => item.id);
        const promises = ids.map(id => this.request.delete(`/equipment/control-devices/${id}`));
        Promise.all(promises).then(results => {
          const successCount = results.filter(res => res.code === "200").length;
          this.$message.success(`成功删除 ${successCount} 个设备`);
          this.load();
        }).catch(() => {
          this.$message.error('批量删除失败');
        });
      });
    },

    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          const submitData = {
            deviceName: this.form.deviceName,
            sid: this.form.sid,
            deviceType: this.form.deviceType,
            controlPid: this.form.controlPid,
            companyId: this.form.companyId,
            greenhouseId: this.form.greenhouseId,
            sortOrder: this.form.sortOrder,
            status: this.form.status
          };

          const request = this.isEdit
            ? this.request.put(`/equipment/control-devices/${this.form.id}`, submitData)
            : this.request.post('/api/equipment/control-devices', submitData);

          request.then(res => {
            this.submitLoading = false;
            if (res.code === "200") {
              this.$message.success(this.isEdit ? '编辑成功' : '新增成功');
              this.dialogVisible = false;
              this.load();
            } else {
              this.$message.error(res.message || (this.isEdit ? '编辑失败' : '新增失败'));
            }
          }).catch(() => {
            this.submitLoading = false;
            this.$message.error(this.isEdit ? '编辑失败' : '新增失败');
          });
        }
      });
    },

    resetForm() {
      this.form = {
        id: null,
        deviceName: '',
        sid: '',
        deviceType: 'switch',
        controlPid: '',
        companyId: this.user.role === '超级管理员' ? null : (this.user.companyid || null),
        greenhouseId: null,
        sortOrder: 0,
        status: 0
      };
      this.formFilteredGreenhouses = [];
    },

    handleDialogClose() {
      this.$confirm('确定关闭吗？未保存的数据将丢失。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dialogVisible = false;
      });
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.load();
    },

    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
      this.load();
    },

    onFormCompanyChange() {
      if (this.form.companyId) {
        this.formFilteredGreenhouses = this.greenhouses.filter(gh => gh.companyid === this.form.companyId);
        this.form.greenhouseId = null;
      } else {
        this.formFilteredGreenhouses = [];
      }
    }
  }
}
</script>

<style scoped>
</style>
